var map = {
	"./ASTON MARTIN.avif": [
		4382,
		4382
	],
	"./BENSON.avif": [
		618,
		618
	],
	"./CHEVROLET.avif": [
		2133,
		2133
	],
	"./DODGE.avif": [
		6288,
		6288
	],
	"./FONTAINE TRAILER.avif": [
		1567,
		1567
	],
	"./FORD.avif": [
		4821,
		4821
	],
	"./FREIGHTLINER.avif": [
		960,
		960
	],
	"./FUSO.avif": [
		6473,
		6473
	],
	"./GMC.avif": [
		6155,
		6155
	],
	"./GREAT DANE TRAILERS.avif": [
		4317,
		4317
	],
	"./HEIL TRAILER INTERNACIONAL.avif": [
		2046,
		2046
	],
	"./HONDA.avif": [
		1764,
		1764
	],
	"./HYUNDAI.avif": [
		5687,
		5687
	],
	"./INTERNATIONAL.avif": [
		2546,
		2546
	],
	"./ISUZU.avif": [
		1772,
		1772
	],
	"./KENWORTH.avif": [
		135,
		135
	],
	"./MAC.avif": [
		4310,
		7152
	],
	"./MACK.avif": [
		3299,
		3299
	],
	"./NISSAN.avif": [
		762,
		762
	],
	"./PETERBILT.avif": [
		4469,
		4469
	],
	"./RAM.avif": [
		9230,
		9230
	],
	"./REITNOUER INC.avif": [
		1976,
		1976
	],
	"./STERLING.avif": [
		2235,
		2235
	],
	"./STOUGHTON TRAILERS.avif": [
		5735,
		5735
	],
	"./TESLA.avif": [
		7799,
		7799
	],
	"./UD TRUCKS.avif": [
		4204,
		4204
	],
	"./UTILITY.avif": [
		3968,
		3968
	],
	"./VOLVO.avif": [
		6555,
		6555
	],
	"./WABASH NATIONAL CORPORATION.avif": [
		1614,
		1614
	],
	"./WABASH.avif": [
		2614,
		2614
	],
	"./WESTERN STAR.avif": [
		8566,
		8566
	],
	"./WHITE TRUCKS.avif": [
		264,
		264
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4522;
module.exports = webpackAsyncContext;